<template>
    <div class="pay-container">
        <!--轮播图区域-->
        <div class="pay-img">
            <img :src="bgImageUrl">
            <!--<img src="/Themes/Rccl.NewTheme/image/success1.jpg" alt="" />-->
            <!--二维码区域-->
            <div class="pay-code">
                <div class="pay-top">
                    <div class="pay-title">
                        <img class="f-fl" src="https://resource.rcclchina.com.cn/paySuccess/gou.jpg">
                        <div class="succ f-fr">
                            <span>支付成功</span>
                            <span>美好旅程即将开启</span>
                        </div>
                    </div>
                    <div class="pay-ma f-fr">
                        <div id="qrcode">
                            <img :src="qrCodeUrl" class="qrCodeImage" style="display: block;">
                        </div>
                        <img src="https://resource.rcclchina.com.cn/logo/logo.jpg" class="qrCodeLogo">
                        <div class="qrcode-text">扫码分享全程</div>
                    </div>
                </div>
                <div class="pay-center">
                    <div class="pay-step">


                        <div class="pay-parah">
                            1.支付成功后，将需要3个工作日左右对您的订单进行确认及系统操作，订单确认后，请务必在开航7天之前办理在线值船，打印“登船证”并于登船当天携带。如遇紧急情况，请您拨打皇家客服专线：400-820-7195
                            。
                        </div>
                        <div class="pay-parah">
                          2.请您务必按照登船证的“指定到达时间”内抵达码头办理登船，否则将影响您的出行。每个航次的具体登船时间请以出行前短信通知为准。
<!--                            2.码头办理登船时间为登船当日 {{pageData.boardingTime}}，请您务必按照登船证的“指定到达时间”内抵达码头办理登船，否则将影响您的出行。每个航次的具体登船时间请以出行前短信通知为准。-->
                        </div>
                        <div class="pay-parah" style="display:flex">
                            <div>3.码头地址：</div>
                            <div v-html="pageData.portAddress">
                            </div>
                        </div>
                    </div>
                    <div class="pay-btn">
                        <router-link to="/Rccl.UserCenter/OrderRecord/List">订到超棒旅程，瞄一眼火热订单！</router-link>
                    </div>
                </div>
            </div>
        </div>
        <div class="pay-shore" v-if="isRowComputed == false">
            <!--左侧 预订皇家岸上观光的三大理由-->
            <div class="shore-content" :style="{width:isRowComputed == false?'884px':'100%'}">
                <div class="shore-reason">
                  <div class="shore-reason-title">
                    <div style="color: #006abb">皇家<span style="color: #fbb913">岸上观光</span> </div>
                    <div style="font-size: 20px">精品游行程享套餐优惠</div>
                  </div>
                    <img src="https://resource.rcclchina.com.cn/cruiseDetail/shorexCompTour/shorex-banner.png" alt="Alternate Text"
                        style="width: 100%;">
                    <div class="shore-banner">
                      <template v-for="(i,idx) in payShorexes">
                        <div class="banner-item" :class="idx===shorexIdx ? 'active':''"
                             v-if="i.outOfStock == false"
                             :key="idx" @click="changeShorexTab(idx,i)">
                          <span v-if="i.shorexType===2">{{ i.shorexName }}</span>
                          <span v-else>皇家常规游 （免费）</span>
                        </div>
                        </template>
                    </div>
                    <div class="good-products" v-if="payShorexes.length > 0">
                        <ul>
                            <li v-for="(cruise, i) in cruises" :key="('cruise_'+i)">
                                <div class="order-title">{{cruise.cruiseName}}</div>
                                <div>
                                    <div class="price-title">
                                        <span class="title-1" v-if="cruise.shorexes[shorexIdx].shorexType===2">{{cruise.shorexes[shorexIdx].shorexName}}</span>
                                        <span class="title-1" v-else>皇家常规游 （免费）</span>
                                        <span class="title-2">价格:${{cruise.shorexes[shorexIdx].price}}/每人 (上船自动房卡扣款)</span>
                                    </div>
                                    <div class="order-intro" v-for="(tour, j) in cruise.shorexes[shorexIdx].shorexTours" :key="('shorex_'+cruise.shorexes[shorexIdx].id+'_tour_'+j)">
                                        <div class="shorex-trip-image" >
                                          <shore-sightsee-swiper :banner-list="tour.bannerList"></shore-sightsee-swiper>
                                        </div>
                                        <div class="order-explain">
                                            <div class="ex-title">{{tour.shorexName}} - {{tour.duration}}</div>
                                            <div class="order-parah" v-html="tour.shorexDescription"></div>
                                            <div class="order-parah" v-html="tour.introWarningText"></div>
                                        </div>
                                    </div>
                                    <div class="up-order">请选择需要升级的订单</div>
                                    <div class="order-info">
                                        <ShorexBookingItem
                                            v-for="(booking) in getBookingByCruise(cruise.shipCode, cruise.sailDate)"
                                            :key="('shorex_'+cruise.shorexes[shorexIdx].id+'_booking_') + booking.bookingId"
                                            :booking="booking"
                                            :shorex="cruise.shorexes[shorexIdx]"
                                            :isSelected="isBookingChecked(cruise.shorexes[shorexIdx].id, booking.id)"
                                            :onShorexBookingSelected="onShorexBookingSelected"
                                            />
                                    </div>
                                </div>

                                <div class="order-notice">
                                    <div class="notice">注:</div>
                                    <div class="tiny">
                                        <div><span class="parah-num">1)</span>目的地的产品及行程仅供参考，实际行程以具体航次和地接社安排为准。</div>
                                        <div><span class="parah-num">2)</span>目的地产品及行程可能受天气、航次情况、交通、政府政策及/或保护公共健康安全之相关要求而取消、变更或调整。</div>
                                        <div><span class="parah-num">3)</span>皇家行前订目前只提供全程观光优惠套餐。您可于登船后购买单一港口观光产品。优惠套餐与单一港口观光产品均数量有限，先到先得。</div>
                                       <div><span class="parah-num">4)</span>如需取消已预订的精品游订单，请联系皇家行前订客服协助操作。</div>
                                    </div>
                                </div>
                                <div class="order-reserve-notice">
                                  <div class="reserve-title">预订须知：</div>
                                  <div class="reserve-main">
                                    <ul>
                                      <li>(1) 精品游行程的最低成团人数为38人，如未能达到最低成团人数，将于开航日前两周通知乘客；</li>
                                      <li>(2) 本网站提供的岸上观光产品的行程与时长等信息仅供参考，景点游览次序、停留时间等会因不可抗力、当地客流量和交通等原因有所调整，具体以地接社实际接待为准；</li>
                                      <li>(3) 岸上观光产品的具体集合时间、地点以及线路安排等信息将通过信件的方式直接放置于乘客的舱房内，乘客需于登船后自行查看舱房内的信件通知，及时获得有关信息，并按照规定的时间和地点集合。通期不予等候、退款或更换，请乘客务必按时出席。</li>
                                      <li>(4) 目的地产品及行程可能受天气、航次情况、交通、政府政策及/或保护公共健康安全之相关要求而取消、变更或调整。</li>
                                      <li>(5) 关于岸上观光产品的咨询、预订和修改，您可以拨打400-820-3187和皇家加勒比游轮度假专家联系。</li>
                                    </ul>
                                  </div>
                                </div>

                            </li>
                        </ul>
                    </div>
                      <div class="unShorex-css" v-else>
                      <img class="null"
                           src="https://resource.rcclchina.com.cn/cruiseDetail/shorexCompTour/noShorex.png">
                      <div class="text">
                        <img src="https://resource.rcclchina.com.cn/cruiseDetail/shorexCompTour/noShorexTextIcon.png"
                             alt="">
                        <div>
                          {{payShorexOnlyStr}}选订开放后， 我们会在第一时间通知您。您也可以密切关注<br>皇家加勒比官方网站， 后续可至<span @click="goToPcp" style="color: #006AB6;cursor: pointer">>>皇家行前订</span>进行预订
                        </div>
                      </div>
                    </div>
                </div>
            </div>

            <ShorexSummary
            v-if="isRowComputed == false"
            :selectedShorexes="selectedShorexes"
            :shorexes="payShorexes"
            :payShorexOnlyStr="payShorexOnlyStr"/>

        </div>
      <div style="width: 1200px;margin: 0 auto" v-if="false">
        <div class="hsbcBanner" v-if="hsbcBanners && hsbcBanners.length">
          <Swiper
              ref="bannerSwiper"
              :options="swiperOptions"
              class="swiper-container swiper-topics topics"
              @click-slide="onShowPopupsImg"
          >
            <SwiperSlide
                v-for="(item, i) in hsbcBanners"
                :key="i"
                class="swiper-slide promoBannerLink external"
            >
              <div style="width: 100%;height: 100%">
                <img :src="item.image" alt=""/>
              </div>
            </SwiperSlide>
            <div
                ref="swiper-pagination"
                class="swiper-pagination"
                v-if="hsbcBanners.length > 1"
                slot="pagination"
            ></div>
          </Swiper>
        </div>
      </div>
      <!--      问卷调查-->
        <div v-if="info" class="survey-question-main" style="margin-top: 20px">
          <div class="main">
            <questionnaire :infoList="info"
                           :isShowTitleNumber="true"
                           :submitStyle="false"
                           :isPaySuccess="true"
                           :orderId="orderId"
            ></questionnaire>
          </div>
        </div>
        <!--更多目的地风光-->
        <div class="shore-img" v-if="isRowComputed == false">
            <a @click="goToPcp">
                <img src="https://resource.rcclchina.com.cn/logo/pcp-banner.jpg" alt="" style="width: 100%;">
            </a>
        </div>
      <PopupsImg v-show="isShowPopupsImg"
                 :imgUrl="popupsImgUrl"
                 @closePopups="onClosePopups"/>
      <div class="hasShore" v-if="isShowHasShore">
        <div class="hasShore-con">
          <div class="con-logo">
            <img src="https://resource.rcclchina.com.cn/logo/PC/logoAnchorBlue.png" alt="">
          </div>
          <div class="con-text">尊敬的客人，皇家官方为您提供多种岸上观光行程如下，您可自主进行选订。<br>如不选订任何行程则视为自助游，您需自行安排目的地游览行程。</div>
          <div class="con-btn" @click="isShowHasShore=false">确定</div>
        </div>
      </div>
    </div>
</template>

<script>
import api from '@/api'
import qrcode from 'qrcode'
import Questionnaire from "@/components/Questionnaire/Questionnaire.vue";
import { Swiper, SwiperSlide, directive} from "vue-awesome-swiper";
import "swiper/css/swiper.css";
import PopupsImg from "@/components/Cruise/popupsImg.vue";
import ShoreSightseeSwiper from "@/components/shoreSightseeSwiper.vue";
const ShorexSummary = () => import('@/components/Booking/PaySuccess/ShorexSummary')
const ShorexBookingItem = () => import('@/components/Booking/PaySuccess/ShorexBookingItem')
export default {
    name: "PaySuccess",
    components: {
      ShoreSightseeSwiper,
      PopupsImg,
      Swiper,
      SwiperSlide,
      Questionnaire,
        ShorexSummary,
        ShorexBookingItem
    },
    directives: {
      swiper: directive,
    },
    data () {
        return {
            isSuccess: false,
            pageData: {},
            qrCodeUrl: "",
            bgImageUrl: "",
            selectedShorexes: [],
            type: '',
            info: null,
            titleCenter: false,
            orderId: '',
            swiperOptions: {
              pagination: {
                el: ".swiper-pagination",
              },
              loop: false,
              autoplay: {
                delay: 5000,
              },
            },
            hsbcBanners:null,
            popupsImgUrl:'',
            isShowPopupsImg:false,
            shorexIdx:0,
            isShowHasShore:false,
            payShorexOnlyStr: null
        }
    },
    beforeMount () {
        this.initPage()
      let query = this.$route.query;
      this.type = query.type || 'HOME';
      this.getQuestions();
      this.orderId = query.orderId || ''
    },
    beforeDestroy () {

    },
    methods: {
        async initPage() {
            const userToken = this.$store.state.user.userToken
            await this.getCruiseBanner()
            if (!userToken || userToken == '') {
                this.$router.push({ name: 'Login', query:{
                    returnUrl: location.href
                }})
                return
            }
            const query = this.$router.currentRoute.query
            if ((!query.payMentId || query.payMentId == '') && !query.paymentId || query.paymentId == '') {
                // return this.$router.push({
                //     name: "BookingListPage"
                // })
            }
            let paymentId = query.payMentId
            if (!paymentId || paymentId == '') {
                paymentId = query.paymentId
            }
            const { success, data, errMsg } = await api.booking.paySuccessV2({
                paymentId: paymentId,
                userName: userToken,
            })
            if (!success) {
                console.error(errMsg)
                // return this.$router.push({
                //     name: "BookingListPage"
                // })
            }
            this.pageData = this.initBookingData(data)
            this.isSuccess = true
            if (data.apiBookings.length > 0) {
                const booking = data.apiBookings[0]
                const url = `${process.env.VUE_APP_BASE_URL}/Rccl.Cruise/CruiseDetail?shipCode=${booking.shipCode}&sailDate=${booking.sailDate}`
                this.qrCodeUrl = await qrcode.toDataURL(url)
                if(booking.isRow == true){
                  this.bgImageUrl = "https://resource.rcclchina.com.cn/Ship/PaySuccess/ROW.jpg";
                }else{
                  switch (booking.shipCode) {
                    case "SC": this.bgImageUrl = "https://resource.rcclchina.com.cn/Ship/PaySuccess/SC.jpg"; break;
                    case "QN": this.bgImageUrl = "https://resource.rcclchina.com.cn/Ship/PaySuccess/QN.jpg"; break;
                    case "VY": this.bgImageUrl = "https://resource.rcclchina.com.cn/Ship/PaySuccess/VY.jpg"; break;
                    default: this.bgImageUrl = "https://resource.rcclchina.com.cn/Ship/PaySuccess/SC.jpg"; break;
                }
                }
                

            }
            if(this.payShorexes && this.payShorexes.length > 0){
              this.isShowHasShore = true
            }
            if (data.payShorexOnly) {
              this.payShorexOnlyStr = "该航次岸上观光精品游行程（付费）尚未开放选订，";
            } else {
              this.payShorexOnlyStr = "该航次岸上观光服务尚未开放选订，";
            }
        },
        // 预处理接口返回数据，把bookingcruise放到booking里面
        initBookingData (data) {
            if (data.apiBookings && data.bookingCruises) {
                data.apiBookings.forEach((booking) => {
                    const cruise = data.bookingCruises.find(r=>r.cruiseId == booking.cruisePartRecord_Id)
                    booking.cruise = cruise
                })
            }
            return data
        },
        getSelectBookingsByShorexId(shorexId) {
            const selectedShorex = this.selectedShorexes.find(r=>r.shorex.id == shorexId)
            if (!selectedShorex) return []
            return selectedShorex.bookings
        },
        isBookingChecked (shorexId, bookingRecordId) {
            const selectedBookings = this.getSelectBookingsByShorexId(shorexId)
            return selectedBookings.some(r=>r.id == bookingRecordId)
        },
        getCruise (shipCode, sailDate) {
            return this.bookingCruises.find(r=>r.shipCode == shipCode && r.sailDate == sailDate)
        },
        getBookingByCruise (shipCode, sailDate) {
            return this.bookings.filter(r=>r.shipCode == shipCode && r.sailDate == sailDate)
        },
        onShorexBookingSelected (isChecked, shorex, booking) {
            let selectedShorex = this.selectedShorexes.find(r=>r.shorex.id == shorex.id)
            if (!isChecked) {
                // 反选
                if (selectedShorex && selectedShorex.bookings) {
                    selectedShorex.bookings = selectedShorex.bookings.filter(r=>r.id != booking.id)
                }
            } else {
                if (!selectedShorex) {
                    selectedShorex = {
                        shorex,
                        bookings: [booking]
                    }
                    this.selectedShorexes.push(selectedShorex)
                } else {
                    if (!selectedShorex.bookings.some(r=>r.id == booking.id)) {
                        selectedShorex.bookings.push(booking)
                    }
                }

                // 岸上观光每张订单只能选一个，如果选了其他的话，需要把其他的删掉
                const otherShorexes = this.selectedShorexes.filter(r=>r.shorex.id != shorex.id)
                otherShorexes.forEach(otherShorex => {
                    if (otherShorex.bookings && otherShorex.bookings.some(r=>r.id == booking.id)) {
                        otherShorex.bookings = otherShorex.bookings.filter(r=>r.id != booking.id)
                    }
                })
            }

            // 全部处理完之后，查找如果selected shorex里面的bookings是空的，需要去掉
            const needDelete = this.selectedShorexes.filter(r=>!r.bookings || r.bookings.length == 0)
            .map(r=>r.shorex.id)
            this.selectedShorexes = this.selectedShorexes.filter(r=> needDelete.indexOf(r.shorex.id)<0)
        },
        async goToPcp () {
            const { data } = await api.user.getPcpToken()
            let token = ""
            if (data && data.length > 0) {
                token = data
            }
            let url = `${process.env.VUE_APP_PCP_URL}/Rccl.Pcp/Home/Index?token=${token}`
            if (this.firstBooking) {
                url += `&sailDate=${this.firstBooking.sailDate}&shipCode=${this.firstBooking.shipCode}&encBookingId=${this.firstBooking.encBookingId}`
            }
            location.href = url
        },
      async getQuestions() {
        this.$loading.show()
        const {success, data} = await api.questionnaire.getCampaignQuestions({
          type: this.type
        })
        this.$loading.hide()
        if(success) {
          let { campaignSurveyPageTitle } = data;
          this.info = this.surveyFormat(data,null);
          this.$store.commit('SET_PAGE_TITLE', campaignSurveyPageTitle)
        }
      },
      // 数据处理
      surveyFormat(rows, type, defaultVal){
        let customTypeIcon = {
          "Booking": "liucheng.png",
          "ImportantInfo": "info-1.png",
          "CustomerService": "custom-service.png"
        }
        rows.categoryQuestionItems && rows.categoryQuestionItems.forEach((row,idx)=> {
          if(rows.categoryQuestionItems[0].questionItems[0].customType === "Point") {
            row.show = idx === 0;
          } else {
            row.show = true;
          }
          row.questionItems && row.questionItems.forEach((qtItem)=> {
            qtItem.value = qtItem.type === 4 ? defaultVal : null;
            qtItem.isFocus = false;
            qtItem.icon = customTypeIcon[qtItem.customType]
            if(qtItem.type === 4) {
              let indexList = [];
              for (let i = 1; i <= 10; i++) {
                indexList.push({
                  text: i,
                  selectClass: ""
                })
              }
              qtItem.indexList = indexList;
            }
            qtItem.optionItems && qtItem.optionItems.forEach((option)=> {
              option.checked = false;
              option.otherVal = "";
              option.isOther = option.optionName === "其他" || option.optionName === "其它"
            })
          })
          row.NO = (idx+1) > 9 ? (idx+1) : `0${idx+1}`
        });
        return rows;
      },
      async getCruiseBanner() {
        const requestData = {
          businessType:2
        }
        const {success, data, errMsg} = await api.cruise.getCruiseBannerApi(requestData);
        if (success) {
          this.hsbcBanners = data
        } else {
          this.$alert.show(errMsg);
        }
      },
      onShowPopupsImg(idx){
        this.popupsImgUrl = ''
        this.popupsImgUrl = this.hsbcBanners[idx].popupImageUrl
        this.isShowPopupsImg = true
      },
      onClosePopups(){
        this.isShowPopupsImg = false
      },
      onSlideChange(){
        //   获取所有class为video-content下的视频
        const videoList = document.querySelectorAll('.video-content video')
        videoList.forEach(item=>{
          item.pause()
        })
      },
      changeShorexTab(idx){
          this.shorexIdx = idx
      }
    },
    computed: {
        bookings () {
            return this.pageData.apiBookings || []
        },
        isRowComputed(){
          if(this.bookings.length>0){
            return this.bookings[0].isRow
          }else{
            return false
          }
        },
        firstBooking () {
            return this.bookings.length > 0 ? this.bookings[0]: null
        },
        bookingCruises () {
            return this.pageData.bookingCruises || []
        },
        freeShorexes() {
            return this.pageData.freeShorexList || []
        },
        payShorexes () {
            return this.pageData.shorexList || []
        },
        hasShorexes () {
            return this.freeShorexes.length > 0 || this.payShorexes.length > 0
        },
        selectedFreeShorex () {
            const shorexIds = this.bookings.filter(r=>r.shorexPartRecord_Id && r.shorexPartRecord_Id > 0)
            .map(r=>r.shorexPartRecord_Id)
            if (shorexIds.length == 0) {
                return {}
            }
            const freeShorex = this.freeShorexes.find(r=>shorexIds.indexOf(r.id) >= 0)
            return freeShorex
        },
        cruises () {
            let cruises = []
            this.payShorexes.forEach((shorex) => {
              console.log('shorex',shorex)
                const shipCode = shorex.ship
                const sailDate = shorex.sailDate.substring(0, 10)
                let cruise = cruises.find(r=>r.shipCode == shipCode && r.sailDate == sailDate)
                if (!cruise) {
                    cruise = {
                        shipCode,
                        sailDate,
                        shorexes: []
                    }
                    // 只添加精品游 1--常规游 2--精品游
                    // if(shorex.shorexType===2){
                    //
                    // }
                    cruise.shorexes = [shorex]
                    const bookingCruise = this.bookingCruises.find(r=>r.shipCode == shipCode && r.sailDate == sailDate)
                    if (bookingCruise && bookingCruise.cruiseName) {
                        cruise.cruiseName = bookingCruise.cruiseName
                    }
                    cruises.push(cruise)
                } else {
                    cruise.shorexes.push(shorex)
                }
            })
          console.log(cruises)
            return cruises
        }
    }



}
</script>

<style lang="less" scoped>
.pay-container {
    width: 100%;
    height: 100%;
    background: #f3f6f8;
    padding-bottom: 25px;
    a:hover, a:link, a:active, a:visited {
        color: #333;
        text-decoration: none;
    }
    .pay-img {
        width: 1200px;
        height: 521px;
        margin: 0 auto;
        overflow: hidden;
        position: relative;
        //margin-bottom: 58px;
        .pay-code {
            width: 472px;
            position: absolute;
            background: #fff;
            left: 68px;
            top: 46px;
            border-radius: 9px;
            padding: 20px 30px 0;
            .pay-top {
                display: flex;
                justify-content: space-around;
            }
            .pay-title img {
                position: relative;
                top: 12px;
                margin-right: 8px;
            }
            .pay-title .succ span {
                display: block;
                margin-top: 4px;
                font-weight: bold;
                font-size: 22px;
                color: #282b2c;
            }
            .pay-ma {
                position: relative;
                .qrCodeImage {
                    width: 90px;
                }
                .qrCodeLogo {
                    position: absolute;
                    width: 25px;
                    top: 32px;
                    left: 32px;
                }
                .qrcode-text {
                    position: relative;
                    top: -8px;
                    left: 3px;
                }
            }
            .pay-center {
                position: relative;
                margin-top: -5px;
            }
            .pay-step {
                width: 386px;
                font-size: 14px;
                line-height: 26px;
            }
            .pay-btn {
                width: 400px;
                height: 54px;
                line-height: 54px;
                background: #ffd800;
                color: #282b2c;
                text-align: center;
                font-weight: 400;
                margin: 20px auto;
                cursor: pointer;
                font-size: 18px;
            }
        }
    }

    .pay-shore {
        width: 1200px;
        margin: 0 auto;
        display: flex;
        justify-content: space-between;
        position: relative;
        margin-top: 30px;
        .shore-content {
            width: 884px;
            background: #fff;
            padding: 40px 20px 0px 20px;
            .shore-title {
                color: #006ab9;
                font-size: 20px;
                font-weight: bold;
                margin-bottom: 20px;
            }
            .shore-reason-title{
              font-size: 34px;
              font-weight: bold;
              margin-bottom: 20px;
              text-align: center;
            }
          .shore-banner{
            width: 100%;
            margin: 25px 0;
            // height: 54px;
            display: flex;
            align-items: center;
            gap: 10px;
            overflow-x: auto;
            overflow-y: hidden;
            .banner-item{
              height: 100%;
              padding: 0 76px;
              background-color: #efefef;
              text-align: center;
              line-height: 54px;
              font-size: 18px;
              color: #2a2a2a;
              white-space: nowrap;
              cursor: pointer;
            }
            .active{
              background-color: #ffd700;
            }
          }
            .parah-num {
                display: inline-block;
                width: 20px;
            }
            .good-products {
                ul li {
                    padding-bottom: 30px;
                    .order-title {
                        background: #006ab9;
                        height: 40px;
                        line-height: 40px;
                        text-align: center;
                        color: #fff;
                        font-size: 20px;
                        font-weight: bold;
                        margin-bottom: 30px;
                    }
                    .price-title {
                        display: flex;
                        .title-1 {
                            font-size: 20px;
                            font-weight: 400;
                            color: #282b2c;
                            display: inline-block;
                            width: 277px;
                        }
                        .title-2 {
                            color: #041455;
                            font-size: 20px;
                            font-weight: 400;
                        }
                    }
                    .order-intro {
                        display: block;
                        margin-top: 12px;
                        .shorex-trip-image {
                            width: 250px;
                            display: inline-block;
                            vertical-align: top;
                            img {
                                width: 100%;
                            }
                        }
                        .order-explain {
                            margin-left: 28px;
                            display: inline-block;
                            vertical-align: top;
                            width: 560px;
                            .ex-title {
                                font-weight: 400;
                                font-size: 15px;
                                color: #282b2c;
                                margin-bottom: 8px;
                            }
                            .order-parah {
                                line-height: 20px;
                                font-size: 14px;
                                color: #5a5a5a;
                                font-weight: 400;
                            }
                        }

                    }
                    .up-order {
                        height: 28px;
                        line-height: 28px;
                        background: #f3f6f8;
                        text-align: center;
                        margin: 14px 0 24px 0;
                        border-radius: 8px;
                        font-weight: 400;
                        color: #747d80;
                    }
                    .order-info {
                        overflow: hidden;
                        margin-bottom: 30px;
                        padding-bottom: 30px;
                        border-bottom: solid 1px #ddd;

                    }
                    .order-notice {
                        display: flex;
                        margin-top: 20px;
                        color: #747d80;
                        font-weight: 500;
                        .notice {
                            margin-right: 12px;
                        }
                    }
                    .order-reserve-notice{
                      & .reserve-title{
                        font-size: 18px;
                        color: #2b2738;
                        margin: 20px 0 17px;
                        font-weight: 500;
                      }
                      & .reserve-main{
                        font-size: 14px;
                        color: #5a5a5a;
                        & ul li{
                          line-height: 25px;
                          padding: 0 0 0 30px;
                        }
                      }
                    }
                }
            }
        }
    }

    .unShorex-css {
        display: flex;
        margin: 20px 0 40px;
        color: #747d80;
        font-weight: 500;
        padding: 0 10px;
        text-align: center;
        align-items: center;
        justify-content: center;
        flex-direction: column;
        .null{
          display: block;
          width: 165px;
          height: 121px;
        }
        .text{
          font-size: 16px;
          color: #2a2a2a;
          display: flex;
          align-items: center;
          gap: 4px;
          font-weight: bold;
          position: relative;
          padding-left: 27px;
          img{
            width: 22px;
            height: 22px;
            position: absolute;
            top: 1px;
            left: 0;
          }
        }
    }

    .shore-img {
        width: 1200px;
        margin: 12px auto;
    }
}
.hsbcBanner{
  width: 100%;
  height: 130px;
  margin: 20px 0;
  &  .swiper-container {
    width: 100%;
    height: 130px;
    border-radius: 5px;
    overflow: hidden;
  }
  & .swiper-slide{
    width: 100%;
    height: 130px;
  }
  & img{
    width: 100%;
    height: 100%;
  }
}
.hasShore{
  width: 100%;
  height: 100%;
  position: fixed;
  top: 0;
  left: 0;
  background: rgba(0,0,0,.5);
  z-index: 9;
  .hasShore-con{
    width: 1000px;
    height: 500px;
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%,-50%);
    background: #fff;
    border-radius: 8px;
    display: flex;
    align-items: center;
    flex-direction: column;
    justify-content: space-between;
    padding: 70px 0;
    .con-logo{
      width: 100px;
      height: 100px;
      img{
        width: 100%;
        height: 100%;
      }
    }
    .con-text{
      font-size: 20px;
      color: #1f1f1f;
      text-align: center;
    }
    .con-btn{
      width: 220px;
      height: 50px;
      color: #292b2a;
      background: #ffd701;
      line-height: 50px;
      text-align: center;
      font-size: 20px;
      cursor: pointer;
    }
  }
}
</style>
